var i={list:"socialmediaiconlinks-module_list__a5ogI",wrapIcons:"socialmediaiconlinks-module_wrapIcons__d3VOG",emailIcon:"socialmediaiconlinks-module_emailIcon__wMP6E"};export{i as default};
